import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { usePage } from 'hooks'
import { FlexRow, SuspenseBoundary } from 'elements'
import InfoItems from 'components/app/InfoItems'
import ReportMenu from './ReportMenu'
import Breadcrumb from 'components/app/Breadcrumb'

export default function ReportHeader() {
  const { header } = usePage()
  const [menuItem, setMenuItem] = useState()
  const [reportCrumbs, setReportCrumbs] = useState()
  const { section } = useParams()

  const reportSections = header?.reportSections

  useEffect(() => {
    if (reportSections && section) {
      setMenuItem(reportSections.find((reportSection) => reportSection.route === section))
    }
  }, [reportSections, section])

  useEffect(() => {
    if (menuItem) {
      setReportCrumbs([{ label: menuItem.label }])
    }
  }, [menuItem])

  return (
    <FlexRow bg="nav.secondary" justifyContent="space-between" position="relative" height="60px">
      <FlexRow alignItems="center" pl="xlarge">
        <Breadcrumb kind="secondary" crumbs={reportCrumbs} />
      </FlexRow>
      <FlexRow mr="xxlarge">{header?.info ? <InfoItems items={header.info} /> : null}</FlexRow>

      {reportSections?.length && (
        <SuspenseBoundary>
          <ReportMenu
            options={reportSections}
            value={menuItem?.value}
            onChange={(tab) => {
              setMenuItem(tab)

              if (tab?.onSelect) {
                tab.onSelect()
              }
            }}
          />
        </SuspenseBoundary>
      )}
    </FlexRow>
  )
}
